import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  withArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 transform active:scale-95';
  const variants = {
    primary: 'bg-gold-gradient hover:bg-gold-gradient-hover text-black shadow-[0_0_20px_rgba(212,160,23,0.3)] hover:shadow-[0_0_30px_rgba(232,163,23,0.5)]',
    outline: 'border-2 border-brand-gold text-brand-gold hover:bg-brand-gold/10',
    ghost: 'text-brand-gold hover:bg-brand-gold/10'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${`${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} text-[20px]`} {...props} data-id="element-317">
      {children}
      {withArrow && <ChevronRight className="ml-2 w-6 h-6" data-id="element-318" />}
    </motion.button>;
}